import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allCategories } from 'app/mocks/data/users/categories'

import { api } from 'app/utils/constants'

import { Manager, ManagerPayload } from 'app/types/park/manager'

export const createManager = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.managers.LIST}`,
    async ({ request }) => {
        const payload = await request.json()

        const payloadParsed = ManagerPayload.safeParse(payload)

        const categoryFound = allCategories.find(
            (category) => category.id === payloadParsed.data.category,
        )

        // Wrong data
        if (!payloadParsed.success || !categoryFound) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Manager>(
            {
                id: 999,
                ...payloadParsed.data,
                category: categoryFound,
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
